<template>
  <div class="Details">
    <div class="bigImg"></div>
    <div class="detailTable">
      <el-table
        :data="tableData"
        stripe
        border
        style="width: 1130px;margin: 0 auto;"
        :header-cell-style="{textAlign: 'center',backgroundColor:'#e96761',color:'#fff'}"
        :header-row-style="{height:'80px'}"
        :cell-style="{ textAlign: 'center' }">
        <el-table-column
          prop="date"
          label=""
          min-width="20%">
        </el-table-column>
        <el-table-column
          prop="name"
          label="伦敦金"
          min-width="40%">
        </el-table-column>
        <el-table-column
          prop="address"
          label="伦敦银"
          min-width="40%">
        </el-table-column>
      </el-table>
    </div>
    <div class="searchBox">
      <a href="javascript:;" @click="changeBox" class="btn_search">交易编码查询</a>
      <div v-if="showBox">
          <div class="twoTap">
            <div class="Tap" :class="controlBox === 1 ? 'active' : ''"  @click="tapClick(1)">交易编码（取消交易编码）申请书</div>
            <div class="Tap" :class="controlBox === 2 ? 'active' : ''" @click="tapClick(2)">查询交易编码</div>
          </div>
          <div v-if="controlBox === 1" class="divTap">
            <h2>一、若客户申请获取交易编码，必须遵守以下规定</h2>
            <p>1、<span class="red download" @click="pdfOpen1">客户需下载、打印《交易编码申请书》</span>，按指示填妥并签署申请书，然后将该申请书拍照或扫描，再把文件发到公司邮箱：<span class="red">cs@rlcvipltd.net</span>。
            所有客户申请交易编码必须签署申请书，其他方式申请无效；</p>
            <p>2、公司收到客户的申请书后,会透过电话核对确认。截止申请时间为每月最后的星期五(下午三时正)，生效时间为截止日期的下一个交易日；</p>
            <p>3、申请书生效后，日后的所有交易都将产生交易编码及相应的费用，不能选择性查看某单一交易编码,不支持申请查看之前交易的编码；</p>
            <p>4、本公司把申请生效当日的交易编码在下一个交易日发送至客户的邮箱；</p>
            <p>5、现货黄金或现货白银的交易编码费用是按手数比例计算，单边为2.5美元/手，双边5美元/手，本公司会在客户建仓时一次性收取双边费用，客户在平仓时无须再次缴付；</p>
            <h2>二、申请[交易编码]成功后，可取消申请查单。若客户想取消获取交易编码，必须遵守以下规定：</h2>
            <p>1. <span class="red download"  @click="pdfOpen2">客户需打印申请书，按指示填妥并签署《取消交易编码申请书》</span>，然后将填妥的申请书拍照或扫描，连同身份证(正反面)及银行卡(正面)图片文件发送到公司邮箱：<span class="red">cs@rlcvipltd.net</span>；</p>
            <p>2. 本公司收到客户的申请书后,会透过电话核对确认。截止申请时间为每月最后的星期五(下午三时正)，生效时间为截止日期的下一个交易日；</p>
            <p>3. 在取消申请完成且生效后，所有交易都不会有交易编码及不需支付交易编码费用；<br>[友情提示]：<br>若要取消此交易编码申请，必须填妥《取消交易编码申请书》，再把文件发到公司邮箱：<span class="red">cs@rlcvipltd.net</span>，以便进一步确认取消，否则交易编码收费一直生效</p>
          </div>
          <div v-if="controlBox === 2" class="divTap">
            <img src="../../static/index/check-pc.png" alt="">
          </div>
      </div>
    </div>
  </div>
  
</template>
<script>
  export default {
    name: 'Details',
    data () {
      return {
         showBox:false,
        searchBox:1,
        // 控制底部searBox
        controlBox:1,
        tableData: [{
          date: '合约单位',
          name: '100',
          address: '5000'
        }, {
          date: '货币单位',
          name: 'USD',
          address: 'USD'
        },{
          date: '报价小数点',
          name: '2',
          address: '3'
        }, {
          date: '点差',
          name: '根据市况浮动',
          address: '根据市况浮动'
        }, {
          date: '单笔交易手数',
          name: '0.01手～20.00手',
          address: '0.01手～20.00手'
        },{
          date: '手数差值',
          name: '0.01手',
          address: '0.01手'
        }, {
          date: '最小挂单距离',
          name: '100点(根据市况浮动)',
          address: '100点(根据市况浮动)'
        },{
          date: '初始保证金',
          name: 'MT4：1000 美元/手起 (分级保证金) \n MT5：合约价值*0.5%起 (分级保证金)',
          address: 'MT4：1000 美元/手起 (分级保证金) \n MT5：合约价值*0.5%起 (分级保证金)'
        }, {
          date: '假期保证金',
          name: '双倍',
          address: '双倍'
        }, {
          date: '锁仓保证金',
          name: '按所需保证金较多的订单收取',
          address: '按所需保证金较多的订单收取'
        },{
          date: '库存费',
          name: '根据市况浮动',
          address: '根据市况浮动'
        },{
          date: '三天利息日',
          name: '周四',
          address: '周四'
        }, {
          date: '交易时间GMT+8',
          name: '周一：06:10-24:00 \n 周二：00:00-04:55 06:05-24:00 \n 周三：00:00-04:55 06:05-24:00 \n 周四：00:00-04:55 06:05-24:00 \n 周五：00:00-04:55 06:05-24:00 \n 周六：00:00-04:45',
          address: '周一：06:10-24:00 \n 周二：00:00-04:55 06:05-24:00 \n 周三：00:00-04:55 06:05-24:00 \n 周四：00:00-04:55 06:05-24:00 \n 周五：00:00-04:55 06:05-24:00 \n 周六：00:00-04:45'
        }, {
          date: '结算时间',
          name: '夏今：5点为结筤时间 \n 冬令：6点为结算时间',
          address: '夏今：5点为结筤时间 \n 冬令：6点为结算时间'
        }]
      }
    },
    created(){
      // 传参控制显示顶部和底部
      this.$emit('controlShow', false);
    },
    methods: {
       //Searchbar点击事件
      tapClick(attr){
        switch(attr){
          case 1:
            this.controlBox = attr;
            break;
          case 2:
            this.controlBox = attr;
            break;
        }
      },
      changeBox(){
        if(this.showBox){
          this.showBox = false
        }else{
          this.showBox = true
        }
      },
      pdfOpen1(){
         var a = document.createElement('a') // 创建一个<a></a>标签
          a.href = '/trade.pdf' 
          a.download = '交易编码申请书-红狮金业' // 设置下载文件文件名
          a.style.display = 'none' // 隐藏a标签
          document.body.appendChild(a) // 将a标签追加到文档对象中
          a.click() // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
          a.remove() // 一次性的，用完就删除a标签
        },
        pdfOpen2(){
         var a = document.createElement('a') // 创建一个<a></a>标签
          a.href = '/trade2.pdf' 
          a.download = '取消交易编码申请书-红狮金业' // 设置下载文件文件名
          a.style.display = 'none' // 隐藏a标签
          document.body.appendChild(a) // 将a标签追加到文档对象中
          a.click() // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
          a.remove() // 一次性的，用完就删除a标签
        }
    },
  }
</script>

<style lang="less" scoped>
  .Details{
    width: 100%;
    .bigImg{
      width: 100%;
      height: 500px;
      background: url('../../static/details/banner.png') no-repeat;
      background-size: cover;
    }
    .detailTable{
      width: 100%;
      box-sizing: border-box;
      padding: 105px 0px;
      margin: 0 auto;
      /deep/ .el-table__row{
        height: 89px;
      }
      /deep/ .el-table__row--striped{
        height: 80px;
      }
      /deep/ .el-table__row td:nth-child(1){
        font-weight: 600 !important;
      }
      /deep/ .el-table .cell {
        white-space: pre-line;
      }
      ::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td{
        background: #f4f4f9;
      }
    }
     .searchBox{
    margin-top: 50px;
    padding-bottom: 50px;
    .btn_search{
      display: block;
      width: 220px;
      height: 50px;
      background: #db0011;
      color: #fff;
      font-size: 20px;
      text-align: center;
      line-height: 50px;
      border-radius: 50px;
      margin: 0 auto;
      cursor: pointer;
    }
    .twoTap{
      
      width: 900px;
      margin: 0 auto;
      display: flex;
      margin-top: 50px;
      .active{
        background: #db0011;
        color: #fff!important;
        cursor: pointer;
      }
      .Tap{
        text-align: center;
        width: 50%;
        cursor: pointer;
        border: #acacac solid 1px;
        color: #acacac;
        padding: 10px 20px;
        font-size: 20px;
        border-radius: 5px 0px 0px 5px;
      }
    }
    .divTap{
      width: 1040px;
      margin: 0 auto;
      padding: 20px;
      p{
        font-size: 18px;
      }
      .red{
        color: red;
      }
      .download{
        cursor: pointer;
      }
    }
  }
  }

  /* ---------------- wap端(≤768px) ---------------- */
  @media screen and (max-width: 768px) {
    .Details{
      .bigImg{
        width: 100%;
        height: 0;
        // 750 * 920 的wap专用banner
        padding-top: 122.66%;
        background: url('../../static/index/wapImg/detailsBanner.jpg') no-repeat;
        background-size: 100% 100%;
      }
      .detailTable{
        box-sizing: border-box;
        padding: 25px 8px;
        // 覆盖el-table的行内宽度
        /deep/ .el-table{
          width: 100% !important;
          font-size: 12px;
        }
        /deep/ .el-table__header-wrapper th{
          padding: 8px 0;
        }
        /deep/ .el-table__row{
          height: auto;
        }
        /deep/ .el-table__row--striped{
          height: auto;
        }
        /deep/ .el-table td{
          padding: 8px 0;
        }
        /deep/ .el-table .cell{
          padding: 0 5px;
          line-height: 20px;
          word-break: break-word;
        }
      }
      .searchBox{
        margin-top: 25px;
        padding-bottom: 30px;
        .btn_search{
          width: 170px;
          height: 42px;
          font-size: 16px;
          line-height: 42px;
        }
        .twoTap{
          width: 100%;
          box-sizing: border-box;
          padding: 0 12px;
          margin-top: 25px;
          .Tap{
            font-size: 14px;
            padding: 8px 5px;
            line-height: 20px;
          }
        }
        .divTap{
          width: 100%;
          box-sizing: border-box;
          padding: 12px;
          h2{
            font-size: 16px;
            line-height: 24px;
          }
          p{
            font-size: 14px;
            line-height: 24px;
            text-align: justify;
          }
          img{
            width: 100%;
            height: auto;
          }
        }
      }
    }
  }
</style>